import React from 'react';

import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';

import { TopBar } from 'client/app/components/TopBar';

type Props = {
  message: string;
};

export function WarningBar({ message }: Props) {
  return (
    <TopBar warning>
      <InfoOutlined color="warning" />
      <Typography variant="h6" color="textPrimary">
        {message}
      </Typography>
    </TopBar>
  );
}
